import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
} from "@mui/material";
import React from "react";
import {
  BaseGrid,
  StyledTableRow,
  TableCellHeader,
  TableCellWidth,
  TitleTypography,
} from "../KandidatViewPage";
import { TrainingResponse } from "../../../models/Training";

type Props = { data: TrainingResponse[] };

export default function DataTrainingKandidatPage({ data }: Props) {
  return (
    <BaseGrid container item xs={12} justifyContent="center">
      <Grid
        container
        item
        xs={12}
        sx={{
          backgroundColor: "#00ACED",
          color: "#fff",
          marginBottom: "4%",
        }}
      >
        <TitleTypography>Data Riwayat Training</TitleTypography>
      </Grid>
      <Grid container item xs={12}>
        <TableContainer component={Paper}>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "rgba(0,0,0,0.1)",
                }}
              >
                <TableCellHeader>Training</TableCellHeader>
                <TableCellHeader>Penyelengara</TableCellHeader>
                <TableCellHeader>Kota</TableCellHeader>
                <TableCellHeader>Mulai</TableCellHeader>
                <TableCellHeader>Selesai</TableCellHeader>
                <TableCellHeader>Biaya</TableCellHeader>
                <TableCellHeader>Lulus</TableCellHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, key) => (
                <StyledTableRow key={key}>
                  <TableCellWidth>{row.TRAINING}</TableCellWidth>
                  <TableCellWidth>{row.PENYELENGARA}</TableCellWidth>
                  <TableCellWidth>{row.KOTA}</TableCellWidth>
                  <TableCellWidth>{row.TAHUN_MULAI}</TableCellWidth>
                  <TableCellWidth>{row.TAHUN_SELESAI}</TableCellWidth>
                  <TableCellWidth>{row.PEMBIAYAAN}</TableCellWidth>
                  <TableCellWidth>{row.LULUS ? "Ya" : "Tidak"}</TableCellWidth>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </BaseGrid>
  );
}
